const toString = number => number.toString().replace('.', ',');

export function round(value, precision) {
  const p = Number('1' + '0'.repeat(precision));

  return Math.round(value * p + (Number.EPSILON || 0)) / p;
}

export function formatNumber(value, precision = null, unit = null) {
  value = precision === null ? Number(value) : round(value, precision);

  let formattedNumber;

  if (value < 10000) {
    formattedNumber = toString(value);
  } else {
    formattedNumber = toString(value).replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      '$1\xa0'
    );
  }

  if (unit) {
    return `${formattedNumber}\xa0${unit}`;
  }

  return formattedNumber;
}
